import physicalSecurityS1 from "@/assets/png/PhysicalSecurity/physicalSecurityS1.png";
import physicalSecurityS2 from "@/assets/png/PhysicalSecurity/physicalSecurityS2.png";
import physicalSecurityS3 from "@/assets/png/PhysicalSecurity/physicalSecurityS3.png";
import physicalSecurityS4 from "@/assets/png/PhysicalSecurity/physicalSecurityS4.png";
import physicalSecurityS5 from "@/assets/png/PhysicalSecurity/physicalSecurityS5.png";
import physicalSecurityS6 from "@/assets/png/PhysicalSecurity/physicalSecurityS6.png";

import { Answer, IQuizList, ISlides } from "@/pages/SecurityAwareness/types";

export const physicalSecurityQuiz: Array<IQuizList> = [
  {
    name: "step1",
    question:
      "1. Which of the following is a key element of physical security?",
    options: [
      { value: "1", label: "Strong passwords" },
      { value: Answer.Correct, label: "Access control to facilities" },
      { value: "3", label: "Using cloud backups" },
      { value: "4", label: "Two-factor authentication" },
    ],
  },
  {
    name: "step2",
    question:
      "2. What should you do if you see an unfamiliar person in a restricted area?",
    options: [
      { value: "1", label: "Ignore them" },
      { value: Answer.Correct, label: "Report to security immediately" },
      { value: "3", label: "Offer them a tour" },
      { value: "4", label: "Give them your access card" },
    ],
  },
  {
    name: "step3",
    question: "3. Which is NOT a good physical security practice?",
    options: [
      { value: "1", label: "Locking server rooms" },
      { value: "2", label: "Using surveillance cameras" },
      {
        value: Answer.Correct,
        label: "Leaving devices unattended in public places",
      },
      { value: "4", label: "Training staff on security" },
    ],
  },
  {
    name: "step4",
    question: "4. Why keep backups in a separate location?",
    options: [
      { value: "1", label: "To make them easier to access" },
      {
        value: Answer.Correct,
        label: "To protect from fire, theft, or flooding",
      },
      { value: "3", label: "To reduce storage costs" },
      { value: "4", label: "To share with external parties" },
    ],
  },
  {
    name: "step5",
    question: "5. What is the biggest risk of poor physical security?",
    options: [
      { value: "1", label: "Slower computer performance" },
      { value: Answer.Correct, label: "Data breaches and equipment loss" },
      { value: "3", label: "Outdated software" },
      { value: "4", label: "More spam emails" },
    ],
  },
];

export const physicalSecuritySlides: Array<ISlides> = [
  { id: 1, content: <img src={physicalSecurityS1} alt="slide1" /> },
  { id: 2, content: <img src={physicalSecurityS2} alt="slide2" /> },
  { id: 3, content: <img src={physicalSecurityS3} alt="slide3" /> },
  { id: 4, content: <img src={physicalSecurityS4} alt="slide4" /> },
  { id: 5, content: <img src={physicalSecurityS5} alt="slide5" /> },
  { id: 6, content: <img src={physicalSecurityS6} alt="slide6" /> },
];
